import { TravellerDocument } from '@wegoTypes/traveller';

export function getPassportDoc(docs?: TravellerDocument[]): TravellerDocument | undefined {
  return docs?.find((doc) => doc.documentType === 'PASSPORT');
}

export function getNationalIdDoc(docs?: TravellerDocument[]): TravellerDocument | undefined {
  return docs?.find((doc) => doc.documentType === 'NATIONAL_ID');
}
